export const ROUTE_PATHS = {
  DASHBOARD: '/',
  ANALYTICS: '/analytics',
  PATIENTS: '/patients',
  REPORTS: '/reports',
} as const;

export interface PatientRecord {
  id: string;
  name: string;
  age: number;
  sex: 'male' | 'female';
  bmi: number;
  children: number;
  smoker: 'yes' | 'no';
  region: 'northeast' | 'northwest' | 'southeast' | 'southwest';
  charges: number;
  lastVisit: string;
  status: 'Stable' | 'Critical' | 'Recovering' | 'Follow-up';
  treatmentType: 'Inpatient' | 'Outpatient' | 'Emergency' | 'Routine';
  riskScore: number;
}

export interface KPIMetric {
  title: string;
  value: string | number;
  change: number;
  trend: 'up' | 'down' | 'neutral';
  icon: string;
  description: string;
  color?: string;
}

export interface ChartConfig {
  dataKey: string;
  label: string;
  color: string;
}

export const REGIONS = [
  'northeast',
  'northwest',
  'southeast',
  'southwest',
] as const;

export const AGE_GROUPS = [
  '18-24',
  '25-34',
  '35-44',
  '45-54',
  '55-64',
  '65+',
] as const;

export const BMI_CATEGORIES = [
  'Underweight',
  'Normal',
  'Overweight',
  'Obese',
] as const;

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

export const calculateAge = (birthDate: string): number => {
  const today = new Date('2026-02-17');
  const birth = new Date(birthDate);
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age;
};

export const getBMICategory = (bmi: number): typeof BMI_CATEGORIES[number] => {
  if (bmi < 18.5) return 'Underweight';
  if (bmi < 25) return 'Normal';
  if (bmi < 30) return 'Overweight';
  return 'Obese';
};

export const getStatusColor = (status: PatientRecord['status']): string => {
  switch (status) {
    case 'Stable':
      return 'oklch(0.68 0.16 165)'; // Green
    case 'Critical':
      return 'oklch(0.55 0.18 28)'; // Red
    case 'Recovering':
      return 'oklch(0.52 0.18 255)'; // Blue
    case 'Follow-up':
      return 'oklch(0.82 0.14 85)'; // Yellow
    default:
      return 'oklch(0.45 0.03 255)';
  }
};